export const moveToSaveForLaterAction = (state, { payload: { id: idToMove } }) => {
	const index = state.items.findIndex((id) => id === idToMove);
	state.items.splice(index, 1);
	state.savedForLaterItems = [...state.savedForLaterItems, idToMove].sort();
};
